export const BLOCK_WIDTH = 32;
export const GRAVITY = 0.7;